var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconCompletedCircleSm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 72,
  height: 72
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#B8BABF",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M36 0c19.882 0 36 16.118 36 36S55.882 72 36 72 0 55.882 0 36 16.118 0 36 0m0 3C17.775 3 3 17.775 3 36s14.775 33 33 33 33-14.775 33-33S54.225 3 36 3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.06 34.825a1.5 1.5 0 1 0-2.12 2.121l9.007 9.008a1.5 1.5 0 0 0 2.121 0L49.751 30.27a1.5 1.5 0 0 0-2.121-2.12L33.007 42.771z"
}))));
export default SvgIconCompletedCircleSm;